import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React from 'react';
import { InviteFunc } from 'types/users';
import UserInviteDialog from './UsersInviteDialog';

interface IUserInviteButtonProps {
	onUsersInvited: () => Promise<void>;
	adminInvite: boolean;
	inviteUrl?: string;
	inviteFunc: InviteFunc;
}

const UserInviteButton: React.FC<IUserInviteButtonProps> = ({
	onUsersInvited,
	adminInvite,
	inviteUrl,
	inviteFunc
}) => {
	const [open, setOpen] = React.useState(false);

	const handleClick = React.useCallback(() => {
		setOpen(!open);
	}, [setOpen, open]);

	const handleSubmit = React.useCallback(() => {
		setOpen(false);
		return onUsersInvited();
	}, [onUsersInvited]);

	return (
		<>
			<Button
				variant="outlined"
				startIcon={<AddIcon />}
				size="small"
				data-testid="users-invite-button"
				onClick={handleClick}
			>
				{intl.tr('button.invite.user')}
			</Button>
			{open && (
				<UserInviteDialog
					onSubmit={handleSubmit}
					onCancel={handleClick}
					adminInvite={adminInvite}
					inviteFunc={inviteFunc}
					inviteUrl={inviteUrl}
				/>
			)}
		</>
	);
};

UserInviteButton.defaultProps = {
	inviteUrl: ''
};

export default UserInviteButton;
